import { parse, formatNumber } from "libphonenumber-js";
import { WidgetConfigurationChannelInfo } from "@/types/inboundWebhookPayload";

export function formatPhoneNumber(number: string) {
  try {
    const parsed = parse(number);
    return formatNumber(parsed, "INTERNATIONAL");
  } catch {
    return number;
  }
}

const humanChannel: Record<WidgetConfigurationChannelInfo["channel"], string> =
  {
    email: "e-mail",
    sms: "SMS",
    whatsapp: "WhatsApp",
  };

export const getHumanChannel = (
  channel: WidgetConfigurationChannelInfo["channel"],
  capitalize: boolean
) => {
  const text = humanChannel[channel];

  return capitalize ? text.charAt(0).toUpperCase() + text.slice(1) : text;
};
